import DayView from './DayView';

export default DayView;